import widgets from '../widgets'

const {
  CHECK_POINT_STATE,
  ALARM_STATE,
  STATUS
} = widgets

export default [
  STATUS({}),
  CHECK_POINT_STATE({}),
  ALARM_STATE({}),
]
